<div class="filter">
  <div
    *ngIf="filterStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'statuses'"
      [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterSupportTypes"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'support_types'"
      [filter]="filterSupportTypes">
    </app-filter-select>
  </div>
  <div
    class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{'FILTERS.PERIOD' | translate}}">
    </app-period>
  </div>
</div>

